import serializeNode from "dom-serializer";
import { isTag } from "domhandler";
import React from "react";

import Math from "../../Math";

import { HtmlToReactProcessor } from "./processor";

const ProcessMath: HtmlToReactProcessor = (node) => {
  if (!isTag(node) || node.name !== "math") return;
  // stricter mode: require xmlns, we are disabling this because there
  // is a lot of math without xmlns in our bank.
  //
  // if(node?.attribs?.xmlns !== "http://www.w3.org/1998/Math/MathML") {
  //   return;
  // }

  return <Math display={false} mathml={serializeNode(node)} />;
};

export default ProcessMath;
